/**
 * A global namespace for `DOMContentLoaded` event.
 */
const DOMContentLoadedEvent = "DOMContentLoaded";
export default DOMContentLoadedEvent;
